import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '@components/ui/Header';
import Footer from '@components/ui/Footer';
import PageHeader from './components/PageHeader';
import BlogsAndNewsPage from './components/BlogsAndNewsPage';
import DownloadableResources from './components/DownloadableResources';
import NewsletterSection from './components/NewsletterSection';

const PatientResourcesPage = () => {
  return (
    <>
      <Helmet>
        <title>Patient Resources - EyeU Kenya | Eye Health Education & Information</title>
        <meta name="description" content="Access comprehensive eye health resources, educational materials, pre-appointment guides, and post-treatment care information from Eye&U Kenya." />
        <meta name="keywords" content="eye health education, patient resources, eye care tips, pre-appointment preparation, post-treatment care, Kenya ophthalmology" />
        <meta property="og:title" content="Patient Resources - EyeU Kenya" />
        <meta property="og:description" content="Access comprehensive eye health resources and educational materials from Eye&U Kenya's expert ophthalmologists." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Patient Resources - EyeU Kenya" />
        <meta name="twitter:description" content="Access comprehensive eye health resources and educational materials from Eye&U Kenya." />
        <link rel="canonical" href="https://eyenu.com//patient-resources-page" />
      </Helmet>

      <div className="min-h-screen bg-background flex flex-col">
        <Header />
        
        <main className="flex-1">
          <PageHeader />
          
          <section className="py-12 md:py-16">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
              <BlogsAndNewsPage />
            </div>
          </section>

          {/* <DownloadableResources /> */}
          <NewsletterSection />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default PatientResourcesPage;